import React, { useState } from 'react';
import { Container, Accordion, Row, Col, Tab, Tabs } from 'react-bootstrap';
import { FaExclamationTriangle, FaComments, FaEnvelope } from 'react-icons/fa';
import {
  PageContainer,
  PageHeader,
  InfoCard,
  AccordionScenario,
  AnimatedSection,
  accordionStyles
} from '../../../components/SharedComponents';

const conversationScenarios = [
  {
    id: 1,
    icon: <FaComments />,
    title: 'Poczekaj wyrównam Ci w przyszłym miesiącu',
    color: '#667eea',
    situation: '„Mamy teraz trudniejszy okres, poczekaj, wyrównam to w przyszłym miesiącu." / „Księgowość się pomyliła, to się zdarza."',
    response: 'Rozumiem, że mogą zdarzyć się pomyłki. Jednak proszę pamiętać, że moje pełne wynagrodzenie oraz składki ZUS są Panu/Pani w 100% refundowane przez państwo. W praktyce jestem zerowym kosztem dla firmy. W związku z tym oczekuję, że brakująca kwota zostanie mi uregulowana do końca tego tygodnia, ponieważ nie ma żadnego finansowego uzasadnienia dla tej zwłoki.'
  },
  {
    id: 2,
    icon: <FaComments />,
    title: 'Ureguluję ale podpisz listę płac',
    color: '#f093fb',
    situation: '„To tylko formalność, muszę mieć tę listę podpisaną do Urzędu Pracy, żeby otrzymać pieniądze." / „Kwota na liście płac jest prawidłowa, to pewnie pomyłka w przelewie."',
    response: 'Nie podpiszę żadnego dokumentu, na którym nie widnieje dokładna kwota, którą rzeczywiście otrzymałem/otrzymałam. Podpisuję tylko autentyczne dokumenty. Podpisywanie list płac z wyższą kwotą niż faktycznie wypłacona, w celu uzyskania refundacji z funduszy publicznych, stanowi niezgodność dokumentacji. Proszę o natychmiastowe wyjaśnienie tej różnicy i przedstawienie mi poprawnej listy płac do wglądu i podpisu.'
  },
  {
    id: 3,
    icon: <FaComments />,
    title: 'Wyznaczenie ostatecznego terminu i kolejnych kroków',
    color: '#4facfe',
    situation: '„Postaram się to uregulować w przyszłym miesiącu, ale muszę to omówić z księgowością." / (Próba zakończenia rozmowy)',
    response: 'Zrozumiałem/Zrozumiałam, że sprawa wymaga omówienia. Proszę jednak, aby moja dopłata została przelana na konto najpóźniej do [Dzień Tygodnia, np. przyszły wtorek], do godziny 12:00. Jeśli tak się nie stanie, będę zmuszony/zmuszona złożyć oficjalne zapytanie do Państwowej Inspekcji Pracy oraz do Cechu/Izby Rzemieślniczej w celu weryfikacji mojej umowy i poprawności dokumentacji, na podstawie której Urząd Pracy wypłaca Panu/Pani refundację.'
  },
  {
    id: 4,
    icon: <FaComments />,
    title: 'Nie rób problemów z powodu tak małych pieniędzy',
    color: '#43e97b',
    situation: '„Nie rób problemu, to są małe pieniądze, skup się na nauce zawodu, a nie na pieniądzach."',
    response: 'Jestem tutaj, aby uczyć się zawodu, ale też zasad rzetelności i uczciwości w biznesie. Oczekuje się ode mnie punktualności i solidności w pracy. W zamian oczekuję, że Pan/Pani, jako mój/moja szef/szefowa, dotrzyma podstawowej zasady każdej umowy, jaką jest pełne i terminowe wynagrodzenie. Zwłaszcza, że ta kwota jest Panu/Pani w całości zwracana. Chcę, by Pan/Pani był/była dla mnie wzorem, a nie powodem do wątpliwości.'
  },
  {
    id: 5,
    icon: <FaComments />,
    title: 'Pogadamy później - gra na zwłokę',
    color: '#f5576c',
    situation: '„Porozmawiamy o tym później, mam teraz spotkanie." / „To wina nowego systemu płacowego, naprawimy to."',
    response: 'Dobrze, to kiedy konkretnie ustalimy ten termin dopłaty? Muszę mieć jasną informację. Kwota [Kwota Należna] musi być zgodna z wytycznymi CECHU. Brakująca różnica musi zostać mi wypłacona. Kiedy to nastąpi?'
  }
];

const writtenTemplates = [
  {
    id: 1,
    icon: <FaEnvelope />,
    title: 'Odwołanie do przepisów i dokumentacji',
    color: '#667eea',
    content: 'Dzień dobry. Zgodnie z przepisami regulującymi zatrudnienie młodocianych i minimalną stawką dla mojego roku nauki, a także z listą płac, którą podpisuję w celu refundacji tych kosztów, kwota do wypłaty powinna wynosić [Podać Kwotę Zgodną z Przepisami]. Rzeczywista kwota, którą otrzymałem/otrzymałam, jest niższa o [Podać Różnicę]. Proszę o niezwłoczne uregulowanie tej różnicy, by uniknąć jakichkolwiek nieścisłości w dokumentacji księgowej.'
  },
  {
    id: 2,
    icon: <FaEnvelope />,
    title: 'Podkreślenie uczciwości i zerowego kosztu',
    color: '#f093fb',
    content: 'Dzień dobry. Szanowny Panie/Pani, cenię sobie możliwość nauki w Pana/Pani firmie i staram się wywiązywać ze swoich obowiązków. Oczekuję jednak, że podstawa mojej umowy, czyli uczciwe i pełne wynagrodzenie zgodne z prawem, będzie również dotrzymana. Jest to pełna kwota, która jest Panu/Pani w całości refundowana przez państwo, więc koszt mojego zatrudnienia jest zerowy. Proszę o wypłacenie pełnej, należnej mi sumy. Zależy mi na tym, by nasze relacje opierały się na wzajemnej rzetelności.'
  },
  {
    id: 3,
    icon: <FaEnvelope />,
    title: 'Ostrzeżenie o konsekwencjach prawnych',
    color: '#4facfe',
    content: 'Dzień dobry. Proszę o wyjaśnienie różnicy w moim wynagrodzeniu. Z tego co wiem, aby Pan/Pani mógł/mogła uzyskać pełną refundację kosztów mojego wynagrodzenia i składek ZUS, musimy mieć zgodność między faktycznie wypłaconą kwotą a listą płac, które ostatecznie trafiają do OHP. Chciałbym uniknąć sytuacji, w której ta dokumentacja jest niespójna, co mogłoby prowadzić do poważnych problemów prawnych związanych z uzyskaniem refundacji. Proszę o dopłatę różnicy, w przeciwnym razie będę zmuszony do powiadomienia o zaistniałych nieścisłościach Państwową Inspekcję Pracy oraz OHP.'
  },
  {
    id: 4,
    icon: <FaEnvelope />,
    title: 'Zapytanie o termin uregulowania',
    color: '#43e97b',
    content: 'Dzień dobry. Otrzymałem/Otrzymałam wynagrodzenie w wysokości [Kwota Otrzymana]. Zgodnie z moim angażem i przepisami, oczekiwana kwota to [Kwota Należna]. W związku z tym, że jest to kwota w pełni refundowana pracodawcy, a różnica jest znacząca, proszę o informację: kiedy i w jaki sposób zostanie uregulowana brakująca część? Zależy mi na tym, by ta sprawa została wyjaśniona jeszcze w tym miesiącu.'
  },
  {
    id: 5,
    icon: <FaEnvelope />,
    title: 'Ultima ratio - powtarzający się problem',
    color: '#f5576c',
    content: 'Dzień dobry. Panie/Pani [Nazwisko], to już [któryś raz/drugi raz] spotykam się z niepełną wypłatą, która jest mi gwarantowana przepisami. Rozumiem, że pomyłki się zdarzają, ale w tej sytuacji jestem prawnie zobowiązany/zobowiązana mieć wypłaconą pełną kwotę, która jest Panu/Pani zwracana. Jeśli brakująca kwota nie zostanie mi przelana do [Podać Datę, np. 3 dni], będę zmuszony/zmuszona skonsultować tę sprawę z Państwową Inspekcją Pracy oraz osobą odpowiedzialną za nadzór nad umowami o pracę młodocianych, w celu ochrony moich praw i upewnienia się co do poprawności dokumentów związanych z refundacją.'
  }
];

const Salary = () => {
  const [activeTab, setActiveTab] = useState('conversation');

  return (
    <PageContainer>
      <Container>
        <style>
          {accordionStyles}
          {`
            .nav-tabs .nav-link {
              color: rgba(255, 255, 255, 0.7);
              border: none;
              border-radius: 15px 15px 0 0;
              padding: 1rem 2rem;
              transition: all 0.3s ease;
            }
            .nav-tabs .nav-link:hover {
              color: white;
              background: rgba(255, 255, 255, 0.05);
            }
            .nav-tabs .nav-link.active {
              color: white !important;
              background: linear-gradient(135deg, rgba(102, 126, 234, 0.3) 0%, rgba(240, 147, 251, 0.3) 100%);
              border: none;
              font-weight: bold;
            }
          `}
        </style>
        
        <PageHeader 
          title="Wynagrodzenie"
          subtitle="Zawalcz o swoje należne wynagrodzenie - gotowe wzory rozmów i pism"
        />

        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <AnimatedSection>
              <InfoCard
                gradient="linear-gradient(135deg, rgba(220, 53, 69, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%)"
                borderColor="rgba(220, 53, 69, 0.3)"
                icon={<FaExclamationTriangle style={{ color: '#dc3545' }} />}
                title="Kiedy wynagrodzenie może być niższe?"
              >
                <p className="mb-2" style={{ fontSize: '1rem', lineHeight: '1.6', color: 'rgba(255,255,255,0.9)' }}>
                  Minimalne wynagrodzenie gwarantują przepisy. Może ono być niższe tylko w 3 przypadkach:
                </p>
                <ul style={{ fontSize: '1rem', lineHeight: '1.8', color: 'rgba(255,255,255,0.9)' }}>
                  <li>Byłeś na L4</li>
                  <li>Byłeś nieobecny na praktykach i była to nieobecność nieusprawiedliwiona</li>
                  <li>Miałeś urlop bezpłatny</li>
                </ul>
                <p className="mb-0 fw-bold" style={{ fontSize: '1rem', lineHeight: '1.6', color: '#ffc107' }}>
                  Jeżeli na wszystkie podane opcje odpowiedź brzmi NIE - zacznij rozmawiać z pracodawcą!
                </p>
              </InfoCard>
            </AnimatedSection>

            <AnimatedSection delay={0.2}>
              <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="mb-4"
                style={{ borderBottom: '2px solid rgba(255,255,255,0.2)' }}
              >
                <Tab 
                  eventKey="conversation" 
                  title={
                    <span>
                      <FaComments className="me-2" />
                      Rozmowa
                    </span>
                  }
                >
                  <div className="mt-4">
                    <Accordion alwaysOpen>
                      {conversationScenarios.map((scenario, index) => (
                        <AccordionScenario
                          key={scenario.id}
                          scenario={scenario}
                          index={index}
                          eventKey={String(index)}
                          argumentLabel="Możliwa reakcja pracodawcy"
                          responseLabel="Asertywna odpowiedź pracownika"
                          argumentField="situation"
                        />
                      ))}
                    </Accordion>
                  </div>
                </Tab>

                <Tab 
                  eventKey="written" 
                  title={
                    <span>
                      <FaEnvelope className="me-2" />
                      Forma pisemna
                    </span>
                  }
                >
                  <div className="mt-4">
                    <AnimatedSection>
                      <InfoCard
                        gradient="linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%)"
                        borderColor="rgba(255, 193, 7, 0.3)"
                        className="mb-4"
                      >
                        <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6', color: 'rgba(255,255,255,0.9)' }}>
                          <strong>Zastosuj formę pisemną, gdy rozmowa nie dała żadnych efektów.</strong> Wyślij list polecony lub zachowaj potwierdzenie doręczenia wiadomości elektronicznej.
                        </p>
                      </InfoCard>
                    </AnimatedSection>

                    <Accordion alwaysOpen>
                      {writtenTemplates.map((template, index) => (
                        <AccordionScenario
                          key={template.id}
                          scenario={{ ...template, response: template.content, argument: '' }}
                          index={index}
                          eventKey={String(index)}
                          responseLabel="Treść pisma"
                          argumentLabel=""
                        />
                      ))}
                    </Accordion>
                  </div>
                </Tab>
              </Tabs>
            </AnimatedSection>

            <AnimatedSection delay={0.6} className="mt-4">
              <InfoCard
                gradient="linear-gradient(135deg, rgba(79, 172, 254, 0.1) 0%, rgba(0, 242, 254, 0.1) 100%)"
                borderColor="rgba(79, 172, 254, 0.3)"
                icon={<FaExclamationTriangle style={{ color: '#f5576c' }} />}
                title="Pamiętaj"
              >
                <ul style={{ fontSize: '1rem', lineHeight: '1.8', marginBottom: 0, color: 'rgba(255,255,255,0.9)' }}>
                  <li>Prawo jest po Twojej stronie</li>
                  <li>Twoje wynagrodzenie jest Ci należne i nie jest kosztem dla pracodawcy</li>
                  <li>Twoja postawa powinna być spokojna, rzeczowa i oparta na faktach</li>
                  <li>Zawsze miej przy sobie notatki z datami i kwotami</li>
                  <li>Zachowaj kopie wszystkich list płac i dokumentów, które podpisujesz</li>
                </ul>
              </InfoCard>
            </AnimatedSection>
          </Col>
        </Row>
      </Container>
    </PageContainer>
  );
};

export default Salary;